import { Datagrid, DatagridProps, Identifier, Record } from "react-admin";
import { DialogEdit } from ".";


export interface DialogGridProps extends DatagridProps {
    record?: Record;
    setRecord?;
    isEdit?: Function;
    children: any[];
};

const DialogGrid = (props: DialogGridProps) => {
    const { record, setRecord, isEdit, rowClick, children, ...others } = props;
    const gridProps = {
        ...others,
        rowClick: rowClick === "edit" ? async (id: Identifier,
            basePath: string,
            record: Record) => {
            if (await isEdit(record)) {
                setRecord(record);
            }
            return undefined;
        } : rowClick
    }
    return <Datagrid {...gridProps}>
        {children}
        {rowClick !== "edit" && <DialogEdit onClick={setRecord} isEdit={isEdit} />}
    </Datagrid>;
};

DialogGrid.defaultProps = {
    isEdit: () => true
}

export default DialogGrid;

